import * as React from "react";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ToggleSpeech } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Tools/Speak/ToggleSpeech";
import * as styles from "../SpeechControls.css";

export function PauseOrResumeLink({
    state, isPaused,
}: {
    state: IBookOfMindState;
    isPaused: boolean;
}) {
    const linkActionText = isPaused ? `Resume` : `Pause`;

    const icon = isPaused ? EGlyphicon.play : EGlyphicon.pause;
    return (
        <IconWithText
            id="refresh"
            iconSuffix={icon}
            whenClicked={() => ToggleSpeech(state)}
            displayAsBlock={false}
            withClass={`${styles.controlButton} ${styles.controlButtonActive}`}
            linkClass={styles.controlButtonTarget}
            useButton={true}
        >
            {linkActionText}
        </IconWithText>
    );
}
